/**
 * Geolocation operations service.
 * Provides async functions for geolocation-related operations.
 */

import { fetchApi } from "common/utils/Api";

interface PostcodeResult {
  postcode: string;
  latitude: number;
  longitude: number;
}

interface IPLocation {
  country: string;
  countryCode: string;
  city?: string;
  latitude?: number;
  longitude?: number;
}

/**
 * Fetch postcodes by query string.
 */
export async function fetchPostcodes(query: string): Promise<PostcodeResult[]> {
  return fetchApi(`postcodes?query=${encodeURIComponent(query)}`) as Promise<
    PostcodeResult[]
  >;
}

/**
 * Fetch location based on IP address.
 */
export async function fetchIPLocation(): Promise<IPLocation> {
  return fetchApi("geolocation/ip") as Promise<IPLocation>;
}

interface NavigatorLocation {
  latitude: number;
  longitude: number;
}

/**
 * Get geolocation from browser navigator API.
 */
export function getNavigatorGeolocation(): Promise<NavigatorLocation | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  });
}
